import React, { useRef, useEffect, useCallback, useState} from 'react';
import Animators from './Animators.js';
import FakeSequencer from './FakeSequencer.js';
import {connect} from 'react-redux';
import '../../LandingParts.scss';
import {usePart} from './usePart.js';

const LandingPart3 = ({setPart, part}) => { 
let ref = useRef(undefined);
return (
    <div ref={part} className="landing-part part-3">
        <div className="mission-subheader left">
        <div>
            Build communities centered around
        </div>
        <div>
            a shared library of creative knowledge.
        </div>
        </div>
        <div className="landing-columns">
        <div>
            <div className="landing-columns">
            <div className="landing-columns">
                <div className="text-box">
                Our creative work isn’t just the end product. The process
                behind it all is what fuels future works. That’s why Zequencer
                lets you build on the collective processes being
                discovered by your peers&#8211; all while remembering who invented what.
                </div>
                <div className="big-text">
                <div>
                    Creative Building Blocks
                </div>
                <img src="/building-blocks.svg"/>
                </div>
            </div>
            </div>
            <div className="landing-columns">
                <div className="blocks text-box big-text">
                <div>Samples</div>
                <div>Presets</div>
                <div>Projects</div>
                </div>
                <div>
                <div className="text-box big-text">
                      Browse and search everything.
                    </div>
                    <div className="text-box big-text">
                      Attributed by source.
                    </div>
                  </div>
              </div>
           </div>
              <div className="landing-column">
                <div className="big-text">
                  <div>
                    Self-Organizing
                  </div>
                  <img src="/self-organizing.svg"/>
                </div>
                <div className="big-text">
                  <div>
                    Shared With Your Squad
                  </div>
                  <img src="/shared-with-squad.svg"/>
                </div>
              </div>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPart3);
